import Cabecera from './cabecera.jpg'
import { Formik, Form, Field, ErrorMessage } from 'formik'
import { useState, useEffect } from 'react'
import Imagen from './imagen.js'

export default function App() {
const back = "https://inscripcion.ar:8003/"

const formato1 = "sm:text-sm lg:text-lg py-5 flex flex-col items-start"
const formato2 = "mr-10 w-64 font-semibold"
const formato3 = "capitalize border-b-2 bg-gray-990 hover:border-red-600 focus:border-red-600 outline-0"
const formato4 = "capitalize outline-0"
const formato_mail = "border-b-2 bg-gray-990 hover:border-red-600 focus:border-red-600 outline-0" 

const [prov, setProv] = useState(21)
const [provincia, setProvincia] = useState([])
const [img, setImg] = useState('')
const [categoria, setCategoria] = useState('Socio')
const [mal_codigo, setMal_codigo] = useState(false)
 
useEffect (() => {
  function traer ()  {
    fetch(back + 'traer_provincia')
    .then (response => response.json())
    .then (json => setProvincia(json))
  }

traer()
},[])

const mostrar_provincias = provincia.map((a) => {
  return <option value={a.id} key={a.id}>{a.nombre}</option>
})

const categorias = [
  {cate: 'Socio' , cartel : 'Socio (Asoc. Cirugía de Rosario o Asoc. Argentina de Cirugía)'},
  {cate: 'NoSocio', cartel : 'No Socio'},
  {cate: 'Residente', cartel: 'Residente'},
  {cate: 'Estudiante', cartel : 'Estudiante'},
  {cate: 'Extranjero', cartel : 'Extranjero'},
  {cate: 'Becado', cartel : 'Becado'}
]


const initialValues = {
    apellido: '',
    nombre: '',
    email: '',
    telefono: '',
    documento: '',
    institucion: '',
    especialidad: '',
    becado: ''
  }

  const validate = ((values) => {
    const errors = {}
    if (!values.apellido) 
      errors.apellido = 'Apellido requerido'
    if (!values.nombre) 
      errors.nombre = 'Nombre requerido'
    if (!values.documento)
      errors.documento = 'Documento requerido'
    else {
      if ((values.documento).length<7) 
        errors.documento = 'Faltan dígitos'
      if ((values.documento).length>8)
        errors.documento = 'Sobran dígitos'
      if (! /^[0-9]+$/.test(values.documento))
        errors.documento = 'Solo dígitos'
    }
    if (!values.telefono)
      errors.telefono='Teléfono requerido'
    else
      if (! /^[0-9]+$/.test(values.telefono))
        errors.telefono = 'Solo dígitos'
    if (!values.email)
      errors.email = 'Correo Electrónico requerido'
    else 
      if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)) 
      errors.email = 'Correo electrónico inválido'
    if (!values.institucion)
      errors.institucion = 'Institución requerida'
    if (!values.especialidad)
      errors.especialidad = 'Especialidad requerida'
    if(!values.becado && categoria==='Becado')
      errors.becado = 'Código requerido'
    return errors;
  })

  
  const onSubmit = ((values) => {
    if ((categoria==='Residente' || categoria==='Estudiante') && img==='') {
      alert('El certificado es obligatorio')
      return
    }
    setHabilitado(false)
    if (img!=='') {
      var data = new FormData()
      data.append('img', img)
      var user = {
        body: data,
        method: 'POST'
      }
      fetch(back + 'subir_imagen',user)
      .then (response => response.json())
      .then (json => {
        const ape = values.apellido[0].toUpperCase() + values.apellido.slice(1)
        const nom = values.nombre[0].toUpperCase() + values.nombre.slice(1)
        const a = {...values, imagen: json.filename, apellido: ape, nombre: nom, categoria: categoria, provinciaId: prov }
        fetch(back + 'inscribir', {
          body: JSON.stringify(a),
          method: 'POST',
          headers: {'Content-Type': 'application/json' }
        })
        .then (response => response.json())
        .then (json => {
          if(json.res==='rechazada')
            setRechazado(1)
        })
      }) 
    } else {
      const ape = values.apellido[0].toUpperCase() + values.apellido.slice(1)
      const nom = values.nombre[0].toUpperCase() + values.nombre.slice(1)
      const a = {...values, imagen: '', apellido: ape, nombre: nom,categoria: categoria, provinciaId: prov }
      fetch(back + 'inscribir', {
        body: JSON.stringify(a),
        method: 'POST',
        headers: {'Content-Type': 'application/json' }
      })
      .then (response => response.json())
      .then (json => {
        if(json.res==='rechazada')
          setRechazado(1)
        if(json.res==='malCodigo')
          setMal_codigo(true)
      })
    }

  })
    const [habilitado, setHabilitado] = useState(true)
    const [rechazado, setRechazado] = useState(0)
   
    return (
     <div className="flex flex-col items-center w-full p-2 bg-blue-200">
      <div className="flex flex-col bg-white sm:w-full md:w-3/5">
        <img src={Cabecera} alt="Imagen del evento"/>
        {habilitado ? (<>
        <div className="sm:text-lg md:text-3xl text-black font-semibold px-2 text-center mt-5 mb-2">
           <p>Formulario de Pre Inscripción</p>
        </div>
        <div className="text-sm px-2">
        <span className="font-semibold underline">Costos abonando antes del 31 de marzo del 2025 </span><br/>
          Socio (Asoc. Cirugía de Rosario o Asoc. Argentina de Cirugía):  $ 80.000<br/>
          No Socio:  $ 100.000<br/>
          Extranjero: $ 100.000<br/>
          Residente: $ 50.000 (Adjuntar certificado de residencia)<br/>
          Estudiante: $ 30.000 (Adjuntar certificado de alumno regular)<br/>
          Becado: (Ingresar código)<br/>
        </div>
        </>)
        : ''
        }
        {habilitado ?
        <Formik
          initialValues={initialValues}
          validate={validate}
          onSubmit={onSubmit}
        >
          {() => (
            <Form>
              <div className="px-2">
           
              <div className={formato1}>
                <label className={formato2} htmlFor="apellido">Apellido</label>
                <Field className={formato3} type="text" name="apellido" />
                <ErrorMessage name="apellido" component="div" className="text-red-600"/>
              </div>
              <div className={formato1}> 
                <label className={formato2} htmlFor="nombre">Nombre</label>
                <Field className={formato3} type="text" name="nombre" />
                <ErrorMessage name="nombre" component="div" className="text-red-600"/>
              </div>
              <div className={formato1}> 
                <label className={formato2} htmlFor="documento">DNI (solo números)</label>
                <Field className={formato3} type="text" name="documento" />
                <ErrorMessage name="documento" component="div" className="text-red-600"/>
              </div>
              <div className={formato1}> 
                <label className={formato2} htmlFor="institucion">Institución</label>
                <Field className={formato3} type="text" name="institucion" />
                <ErrorMessage name="institucion" component="div" className="text-red-600"/>
              </div>
              <div className={formato1}> 
                <label className={formato2} htmlFor="especialidad">Especialidad</label>
                <Field className={formato3} type="text" name="especialidad" />
                <ErrorMessage name="especialidad" component="div" className="text-red-600"/>
              </div>
              <div className={formato1}>
                <label className={formato2} htmlFor="email">Email</label>
                <Field className={formato_mail} type="email" name="email" />
                <ErrorMessage name="email" component="div" className="text-red-600"/>
              </div> 
              <div className={formato1}>
                <label className={formato2} htmlFor="telefono">Celular (característica sin 0 y sin el 15)</label>
                <Field className={formato3} type="text" name="telefono" />
                <ErrorMessage name="telefono" component="div" className="text-red-600"/>
              </div>
              <div className={formato1}>
                <label className={formato2} htmlFor="provincia">Provincia</label>
                <Field as="select" className={formato4} name="provincia" value={prov} onChange={e => setProv(e.target.value)}>
                    {mostrar_provincias}
                </Field>
              </div>
              <div className={formato1}>
                <label className={formato2} htmlFor="categoria">Categoría</label>
                {categorias.map(a => {
                  return (<>
                  <div className="flex flex-row ml-2">
                    <input 
                      type="radio"
                      name="categoria"
                      value={a.cate}
                      checked={a.cate===categoria}
                      onChange={e => {setImg(''); setCategoria(e.target.value)}}
                      key={a.cate}
                    />
                    
                    <label className="ml-3">{a.cartel}</label>
                  </div>
                  </>)
                })}
              </div>
              {categoria==='Residente' || categoria==='Estudiante' ? 
                    <Imagen imagen={img} setImagen={setImg} />
                  :''}
              {categoria==='Becado' ? 
                   <div className={formato1}>
                   <label className={formato2} htmlFor="becado">Código</label>
                   <Field className={formato3} type="text" name="becado" />
                   <ErrorMessage name="becado" component="div" className="text-red-600"/>
                 </div>
                  :''}
              </div>
              <div className="flex flex-col items-center mb-5">
              
              {habilitado ? 
                <button type="submit" className="md:text-2xl mt-10 p-5 rounded-full bg-blue-200 hover:bg-blue-800 hover:text-white">
                PRE INSCRIBIRME
                </button>
              :
                <button type="submit" className="md:text-2xl mt-10 p-5 rounded-full bg-gray-200" disabled>
                PRE INSCRIBIRME
                </button>
                }

              </div>
            </Form>
          )}
        </Formik>
        : 
        <div className="flex flex-col mt-5 sm:text-sm sm:text-justify md:text-center md:text-lg px-2">
          {!rechazado && categoria==='Becado' && mal_codigo ?
                <p className="font-semibold mt-5">Este código no es válido</p>
              :
              ''}
          {!rechazado && categoria!=='Becado' ?
            (<>
              <p>Tu preinscripción a la <span className="font-semibold ml-2">Jornada de Cirugía Otoño 2025 </span></p>
              <p> nos ha llegado correctamente, recibirás por mail los datos bancarios para efectivizar el pago de la jornada.</p>
              
              <br/>
              <p>En caso de no verlo en tu casilla, verificá SPAM y/o correo no deseado</p>
            </>)
            : ''}
            {!rechazado && categoria==='Becado' && !mal_codigo?
            (<>
              <p>Tu preinscripción a la <span className="font-semibold ml-2">Jornada de Cirugía Otoño 2025 </span> nos ha llegado correctamente,</p>
              <p>Vas a recibir al correo el código QR, para que puedas ingresar a la jornada</p>
              
              <br/>
              <p>En caso de no verlo en tu casilla, verificá SPAM y/o correo no deseado</p>
            </>)
            :''
          }
          {rechazado ?
            <p className="font-semibold mt-5">Este número de documento ya se encuentra registrado</p>
            : ''
          }
          </div>
        }
        </div>
      </div>   
    )
  }


